import Signaler from 'signalerjs';
import features, {UPLOAD_ONE_COLOR_FLAG} from '~/constants/FeatureFlags';

// These feature flags are not automatically sampled at pageload, and need to
// be explicitly sampled closer to the experience being tested.
const BLOCKLIST = ['realTimePricing_v19', UPLOAD_ONE_COLOR_FLAG];

const signaler = new Signaler(features);
const featuresToSet = Object.keys(features).filter(feature => {
  return !BLOCKLIST.includes(feature);
});

for (const feature of featuresToSet) {
  signaler.featureFlag(feature);
}
export default signaler;
